import { render, staticRenderFns } from "./ResolDeltaSolMX_3_1d00.vue?vue&type=template&id=c1d52d5c&"
import script from "./ResolDeltaSolMX_3_1d00.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaSolMX_3_1d00.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports